<template>
  <div id="app">
    <router-view v-if="this.$route.name === 'Index'"></router-view>
    <layout v-else></layout>
  </div>
</template>
<script>
export default {
    name: 'app',
    components: {
      'layout': require('./components/layout/layout')
    }
}
</script>



// WEBPACK FOOTER //
// App.vue?3619e78f